import {
    CreateNewPasswordRequestSchema, NewPasswordRequestSchema,
    ResetPasswordEmailRequestSchema,
    SignInRequestSchema,
    SignUpRequestSchema,
} from "../schemas/requests/auth";
import requestApi from "../fetchApi";

export class AuthApi {
    static baseUrl: string = "jwt";
    static regUrl: string = "/api/users/signup";

    static async signIn(data: SignInRequestSchema): Promise<any> {
        return requestApi.POST(`/api/jwt/obtain`, {
            body: data,
        });
    }

    static async signUp(data: SignUpRequestSchema): Promise<any> {
        return requestApi.POST(`${this.regUrl}`, {
            body: data,
        });
    }
    static async setNewPassword(
        data: NewPasswordRequestSchema,
        secret: string,
        user_id: string | number,
        lang: string,
    ): Promise<any> {
        return requestApi.POST(`/api/users/set-password?secret=${secret}&user_id=${user_id}&lang=${lang}`, {
            body: data,
        });
    }
    static async getWSTicket(): Promise<any> {
        return requestApi.GET(`/api/jwt/ws-ticket`);
    }

    static async sendResetPswEmail(data: ResetPasswordEmailRequestSchema): Promise<any> {
        return requestApi.POST("/api/users/send-reset-password-request", {
            body: data,
        });
    }

    static deleteProfile() {
        return requestApi.DELETE(`/api/users/me`);
    }
}
